// Decide before SDK initialisation and keep the choice for this document's
// lifetime. Content query parameters and client-side navigation cannot enable it.
export const isEmbedAnalyticsDisabled = typeof window !== 'undefined' &&
  window.location.pathname.toLowerCase().startsWith('/embed/') &&
  new URLSearchParams(window.location.search).get('analytics') === 'off'
